<template>
  <div class="directory-sort">
    <div class="styled-dropdown--fill">
      <select aria-label="Sort by Name">
        <option data-placeholder>Sort by Name</option>

        <option
          v-for="option in options"
          :key="option.label"
          :value="option.value"
          :selected="selectedSort === option.value"
        >
          Sort {{ option.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import easydropdown from 'easydropdown-a11y'

export default {
  name: 'DirectorySort',

  props: {
    type: {
      type: String
    },
    sort: {
      type: Array,
      default: ['name', 'asc']
    }
  },

  computed: {
    options() {
      const opts = [
        {
          label: 'Name (A-Z)',
          value: 'name-asc'
        },
        {
          label: 'Name (Z-A)',
          value: 'name-desc'
        }
      ]

      return opts
    },

    selectedSort() {
      return this.sort.join('-')
    }
  },

  methods: {
    setSort(value) {
      this.$parent.setSort(value.split('-'))
    }
  },

  mounted () {
    easydropdown(this.$el.querySelector('select'), {
      callbacks: {
        onSelect: () => this.setSort(this.$el.querySelector('select').value)
      }
    })
  }
}
</script>
